import { Component } from '@angular/core';

@Component({
  selector: 'loading-wheel',
  templateUrl: './loading-wheel.component.html',
  styleUrl: './loading-wheel.component.scss'
})
export class LoadingWheelComponent {}
